import React, {  useState, useEffect } from 'react';
import logo from "./assets/images/logo.png";
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Container, Offcanvas, NavDropdown } from 'react-bootstrap';
import axios from 'axios';
import { MyApi } from './MyApi';
 function HeaderTop() {
  const [show, setShow] = useState(false); 
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true); 
  const [services, setServices] = useState([]);  

  // Fetch Services API
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + MyApi.CAT_MENU, {
          headers: { Authorization: MyApi.SECRET_KEY },
        });
        if (res.data.status) setServices(res.data.data);
      } catch (err) {
        console.error("Menu API error:", err);
      }
    };
    fetchServices();
  }, []);

  return (
    <div className='header_sty'>
    <Navbar expand="lg" data-bs-theme="light" className="shadow-sm menu_style">
      <Container>
      <div className='d-flex align-items-center justify-content-between wmob100'>
          <Navbar.Brand as={Link} to="/"><img src={logo} alt="" /></Navbar.Brand>
          <div><Navbar.Toggle onClick={handleShow}><i className="fa-solid fa-bars"></i></Navbar.Toggle></div>
          </div>
        <Navbar.Offcanvas show={show} onHide={handleClose} placement="start">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img src={logo} alt="" height="40" />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              <NavLink className="nav-link" to="/" onClick={handleClose}><i className="bi bi-house-door"></i> Home</NavLink>
              <NavLink className="nav-link" to="/about-us" onClick={handleClose}>About Us</NavLink>
             
                <NavDropdown title="Our Tours" id="tours-dropdown">
                {services.length > 0 ? (
                  services.map((item) => (
                    <NavDropdown.Item
                      as={Link}
                      to={`/our-tours/${item.categoryurl}`} // make sure your route matches this
                      key={item.id} // use a unique key
                      onClick={handleClose} >
                      {item.categoryheading}
                    </NavDropdown.Item>
                  ))
                ) : (
                  <NavDropdown.Item disabled>Loading...</NavDropdown.Item>
                )}
              </NavDropdown>
                <NavLink className="nav-link" to="/hire-a-cab" onClick={handleClose}>Hire a Cab</NavLink>  
               <NavDropdown title="Gallery" id="services-dropdown">
                  <NavDropdown.Item as={Link} to="/photo-gallery" key="" onClick={handleClose}>Photo Gallery</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/video-gallery" key="" onClick={handleClose}>Video Gallery</NavDropdown.Item>
                  
              </NavDropdown> 
              
              
               <NavLink className="nav-link" to="/feedback" onClick={handleClose}>Feedback</NavLink> 
              <NavLink className="nav-link" to="/contact-us" onClick={handleClose}>Contact Us</NavLink>
             </Nav>
            {/* <div className="d-flex"> 
              <Link to="/contact-us"></Link>
            </div> */}
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
    </div>
  );
}

export default HeaderTop;
